var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask937_3_158",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern8464)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask937_3_158)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#9D9FA2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern8464",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1033_158",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1033_158",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAFIklEQVR4nO2dT48URRiHn11MjMJKUDkQVoKeNMaDMcFEjkowwQAJQS8ePRgV/Ap+AEn06EGjJl44CP5BIsYvIAf1xHpBYVeIRjfujkoiO46Hmo1kmKmq6a6u6p739yTvZbtT9W6/z/a8U9tTA0IIIYQQQgghhBBleRQ4C/w6jLPDn3WFrudflH3ADWAwEjeGx9pO1/MvzgVuv3ibcaFgXrF0Pf/i9Jh8AXsF84qlU/nPlU5gDIPA8TbmfCudyn++dAKiLBLAOBLAOHVfj/YAR4BDwF5gEdhaNynh5S9gBfgJ+Bz4BFjOncRu4B1gg8kdryJP9IHTuD/ALBzF/1ZHUSbWgcOeuiXhdZxxpX9ZxfjoAycnVq8mR1HxuxB9prgTxDaBi8AlYFvswKIoPeBh4FroxC2RA74FPFknI5GVO4HtwGehE2PuAHuAy8TLItpBH/fOYKXuQCcIv+5cBY4BC3UnE0EWcP3YEuG6vJpiwvOBSa4C96aYSEzFDty199XmXIqJfghMcizFJKISx/HXZinFJOuBSXTbL8c9+GuzHhogpgkcJBhDNEet+ui/gcaRAMaRAMaRAMaRAMaRAMaRAMaRAMaRAMaRAMaRAMa5I8EYobVo0WJ0BzCOBDCOBDCOBDCOBDCOBDCOBDBOinUAPRNYllrrMLoDGEcCGEcCGEcCGEcCGEcCGEcCGEcCGEcCGEcCGEcCpOUuZnCr3NA+NMJtyfYV/2+d+y3wTKa5G6+PBPBzEFjj9utyEziQYX4JUJCXcYWedG2+z5CDBCjAPPAm4WszwO3j0yQSIDN3A2eIK35/eH6TSICM7AIuElf8AfB1hpwkQCYeA64QX/xV8nxbqATIwLOM7/QnxRWcMDmQAA3zEvAP8cX/Dre9fi4kQEPMAW8QX/gBrjlsuukbRQI0wFbiO/3NeJsyS+sSIDG7gG+IL/wGibZlr4gJAe4H3gN+Af4GPgYeamCeaTv9NVyDWJKZF2An4/fF/x14IuE8be70fcy8AB945l4ljQShNf3RuIh7qWgDMy3AHO4v3Td/HQnmgVOB8UfjDO36n/9MCzBP3HvwKhJU6fRP0b6HaGZaAIAvInKYVoJp1/Rv4l4m2sjMC/AI8c1ZjARd7PR9zLwAAE8RL8EfwL4J4xwYHo8t/grweBO/UEJMCAD1JWj7mn5VzAgA1SToypp+VUwJALCf8FfZbcYq8GXkuZvRxk7fhzkBYLo7QWyUXtOvikkBIK0EPeC5vOknw6wAkEaCLnT6PkwLAPUk6Eqn78O8AFBNgi51+j4kwJBpJCj19E4TSIBbCEnQ1U7fhwQYYT/jl3vbvqZfFQkwhr3AaeA34DrwEfBg0Yyao1Z9Yvb5DQ2ivYLLUqs+s9IIiYpIAONIAONIAONIAONIAONIAONIAONIAONIAONIAONIAONIAONIAONIAOPECNALHF9IkYioxPbA8VDtogS4Hjj+dMQYohkOBo5fSzHJefyPHC0BO1JMJKbiPmAZf23OpZjotcAkA9wuXsdpfm984a7x84SLPwBeCQ0W8zzfA8CPwJZq+YpCbOAehF3xnRTTAywD76fISGTlXQLFh/gnencDl1DH3xXWcd9kFmrgo9cBfgZewH0Fimg3/wIvElH8KpzESRDz+TtF/ugDJyZWLxGHid+iRZEv1si4ycVO3Cdsp9lfV9FM9IEPqbh3cd2PdS0CR4BDuLcci8C2mmMKP3/iuvvLuIWeT4no9oUQQgghhBBCCCH+AyaaceAMdFZDAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings);
export default __webpack_public_path__ + "static/media/bookings.ab08b87a6dcf60a93dfd2adcd066a75b.svg";
export { ForwardRef as ReactComponent };